import { useContext, useMemo } from "react";
import { DevContext } from "./../../../ricos-context/DevContext";
import { useRequestService } from "./../../request-service-provider/request-service-provider";
const pageTypePaths = {
  blogPost: "blog-posts",
  staticPage: "static-pages"
};
const fetchJson = async (makeRequest, path, params) => {
  const response = await makeRequest(`/_api/ricos-site-pages/${path}`, {
    body: JSON.stringify(params),
    headers: {
      "Content-Type": "application/json"
    },
    method: "POST"
  });
  return response.json();
};
const fetchItems = async (makeRequest, pageType, params) => {
  const result = await fetchJson(makeRequest, pageTypePaths[pageType], params);
  return {
    ...result,
    items: result.items.map((item) => ({
      ...item,
      updatedDate: item.updatedDate ? new Date(item.updatedDate) : void 0
    }))
  };
};
const useFetchSitePages = () => {
  const { makeRequest } = useRequestService();
  const fetchSitePages = useMemo(
    () => (pageType, params) => fetchItems(makeRequest, pageType, params),
    [makeRequest]
  );
  return useContext(DevContext)?.fetchSitePages || fetchSitePages;
};
export {
  useFetchSitePages
};
//# sourceMappingURL=use-fetch-site-pages.js.map
